import gql from 'graphql-tag'

export const ROUTES_QUERY = gql`
query CruiseCompassRoutes($shipId: ID!){
  shipRoutes(shipId: $shipId){
    results {
      name
      routeId
      duration
      ship {
        id
        name
      }
      schedules {
        dateStart
        dateEnd
        routeId
        cruiseId
      }
    }
  }
}
`